import React, { useState, useEffect, useRef } from "react";
import Slider from 'react-slick';
import { InView } from 'react-intersection-observer';
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import LazyLoad from 'react-lazyload';


export default function MainBanner(props) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let slider1 = null;
  let slider2 = null;

  useEffect(() => {
      setNav1(slider1);
      setNav2(slider2);
  }, []);


  const { header, content, bannerItems, mediaType, mediaSource, mediaClass, classes, bannerSliderImageItems } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 100;

  useEffect(() => {
    if (!ref.current) return;

    const setValues = () => {
      setElementTop(ref.current.offsetTop);
      setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
      setClientHeight(window.innerHeight);
    };
    setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  }, [ref]);

  const opacity = useTransform(scrollY, [elementBottom, elementTop], [0, 1], "anticipate");

  const handleChange = (inView) => {
    inView ? props.setShowVerticleNav(false) : props.setShowVerticleNav(true);
    setIsVisible(inView);
  };

  const settings = {
    appendDots: dots => (
        <ul className="slick-dots"> {dots} </ul>
    ),
    customPaging: i => (
      <button>
        <span>0{i + 1}</span>
      </button>
    )
  };

  return (
    <InView onChange={handleChange}>
      <div ref={ref} className={`page-main-banner-section section-gap d-flex align-v-center page-main-banner-container-width ${classes}`}>
      <div className="container slider-container">
          <div className="row d-flex flex-wrap">
            <div className="col page-main-banner-detail d-flex align-v-center">
              <div className="page-main-banner-detail-inner">
              <Slider
                    
                    asNavFor={nav1}
                    ref={slider => (slider2 = slider)}
                    dots={true}
                    arrows={false}
                    infinite={true}
                    slidesToShow={1}
                    slidesToScroll={1}
                    focusOnSelect={true}
                    fade={true}
                    speed={1000}
                    autoplaySpeed= {7000}
                    autoplay= {true}
                    {...settings}
                    >
                {bannerItems && bannerItems.map((item,index) => {
                  return (
                    <div key={index}>
                      <div><span className="theme-color-title">{item.subheader}</span></div>
                      <div><h1 className="h1">{item.header}</h1></div>
                      <div><p >{item.content}</p></div>
                      <div><a href={item.link} className='button button-white right-arrow'>{item.buttonText}</a></div>
                    </div>
                  );
                })}
              </Slider>
                
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row d-flex flex-wrap">
            <div className="col page-main-banner-image d-flex"><div>
              
                <motion.div style={{ opacity }}>
                <Slider
                    asNavFor={nav2}
                    ref={slider => (slider1 = slider)}
                    //infinite={true}
                    arrows={false}
                    fade={true}
                    speed={1000}
                    cssEase={'linear'}
                    autoplaySpeed= {5000}
                    autoplay= {true}  
                    slidesToShow={1}>
                      {bannerSliderImageItems && bannerSliderImageItems.map((item,index) => {
                      return (
                          <div key={index}>
                            <LazyLoad><img src={item.image} alt={item.imagealt}  title={item.imagetitle}  /></LazyLoad>
                          </div>
                          );
                        })}
                  </Slider>
                </motion.div>
              
            </div></div>
          </div>
        </div>
           
      </div>
    </InView>
  );
}
